
<template>
  <v-container fluid>
    <supplier-list></supplier-list>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'PageSupplierList',
  //mixins: [ validations ],
  components: {
    SupplierList: () => import('@/_backoffice/_registrations/components/supplier/SupplierList.vue'),
  },
}
</script>